import { render, staticRenderFns } from "./b2b-app-loading.vue?vue&type=template&id=23242ec6&scoped=true"
import script from "./b2b-app-loading.vue?vue&type=script&lang=js"
export * from "./b2b-app-loading.vue?vue&type=script&lang=js"
import style0 from "./b2b-app-loading.vue?vue&type=style&index=0&id=23242ec6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23242ec6",
  null
  
)

export default component.exports